import './Manuals.scss';

import Layout from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Layout/Layout';
import { LocalizedLink } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import React from 'react';
import SEO from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Seo';
import { graphql } from 'gatsby';
import manualIcon from '@progymedia/sbi-web-occ/src/images/icons/icon-Manuels-Page-Icon-2.svg';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

export const query = graphql`
    query ($code: String!) {
        productsJson(code: { eq: $code }) {
            code
            id
            documents {
                en_CA
                en_US
                fr_CA
            }
            title {
                en_CA
                en_US
                fr_CA
            }
        }
    }
`;

export default function Manuals({ data }) {
    const manual = data.productsJson;
    const { t } = useTranslation('templatePages');
    const { currentLocale } = usePageLocalization();

    return (
        <Layout>
            <SEO
                title={t('metadata:manuals.title', { SKU: manual?.code })}
                description={
                    t('metadata:manuals.description', {
                        SKU: manual?.code,
                    }) as string
                }
            />
            <div className='container manuals'>
                <LocalizedLink className='return-to-parts' to='/archives/'>
                    <span className='iconfont iconfont-return'></span>
                    {t('part-return-message')}
                </LocalizedLink>
                <div className='row manuals-section'>
                    <div id='primary'>
                        <h1 className='title'>
                            {manual?.title[currentLocale]}
                        </h1>
                        <h5 className='subtitle'>{t('manuals-title')}</h5>
                        <div className='documents'>
                            {manual.documents.map((document, index) => {
                                if (document?.[currentLocale] === 'null')
                                    return;

                                return (
                                    <a
                                        key={index}
                                        rel='noreferrer'
                                        target='_blank'
                                        href={
                                            '/file/' + document?.[currentLocale]
                                        }
                                        className='document'
                                    >
                                        <img
                                            width={30}
                                            src={manualIcon}
                                            alt=''
                                            height={57}
                                        />

                                        <div className='document-info'>
                                            <p>{document[currentLocale]}</p>
                                            <p className='fileType'>(PDF)</p>
                                        </div>
                                        <span className='iconfont iconfont-download download-icon'></span>
                                    </a>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}
